import React, {useState, useEffect} from "react";
import {SetMetaData} from './../../helper/page-title';
import moment from 'moment';
import {post_api_call,
        error_api_call
      } from './../../actions/action-creators/common';
import { alertResponseMessage } from "../../actions/action-creators/response";
//Modal
import ModalMasterDetail from "../../modal/master-detail";
import FormDataAff from "../../data/formData/affiliate/affiliate";
import FormDataSetting from "../../data/formData/affiliate/settings";
import ModalMaster from "../../modal/master";
const {
    fieldAffViewBasic,
    fieldAffViewType,
    fieldAffViewChannel,
    fieldAffViewPlan,
    fieldAffViewBank,
} = FormDataAff;

const {
    fieldValuesConfig,
    fieldValidationConfig,
    fieldAffConfig,
    optionComm
} = FormDataSetting;

function AffiliatePendingList(props){
    SetMetaData("Manage Affliate Requests", "", "");
    const [isLoading, setIsLoading] = useState(true);
    const [modalLoader, setModalLoader] = useState({detail: false, config: false});
    const [modalToggle, setModalToggle] = useState({detail: false, config: false});
    const [masterTableData, setMasterTableData] = useState([]);
    //Single Details
    const [detailedAffData, setDetailedAffData] = useState({});
    const [configAffData, setConfigAffData] = useState({});
    //Get Data for Dropdown
    const fetchAffiList = async() => {
      try{
        const oppoApiData = await post_api_call('affiliates-pending', {});
        if(oppoApiData.status === 200){
          setMasterTableData(oppoApiData.data);
          setIsLoading(false);
        }
      }catch(e){
        error_api_call({error: `admin|affiliate|list|fetchAffiList|${e}`});
      }
    }
    useEffect(() => {
      //Initial API Data
      fetchAffiList();
    }, []);
    //View Data
    const loadViewModal = async(e, load_type, aff_tmp_id, data={}) => {
      e.preventDefault();
      try{
        //Page Loading
        toggleModal(e, load_type, true, '', load_type);
        setModalLoader({...modalLoader, [load_type]: true});
        // const oppoApiData = await post_api_call_main(`opportunity/details/${aff_tmp_id}`, {fetch_type: 'admin'});
        // if(oppoApiData.status === 200){
            if(load_type === 'detail'){
              setDetailedAffData(data);
            }else if(load_type === 'config'){
              setConfigAffData({...fieldValuesConfig});
            }
          setModalLoader({...modalLoader, [load_type]: false});
        // }else{
        //   alertResponseMessage({alert_type: 2, message: "Error Loading Data"});
        // }
      }catch(error){
        error_api_call({error: `admin|affiliate|list|loadViewModal|${error}`});
        alertResponseMessage({alert_type: 2, message: "Error Loading Data"});
      }
    }
    //Approve Toggle
    const approveToggle = async(e, type, is_approved, aff_tmp_id) => {
        e.preventDefault();
        try{
          // approval
          if (window.confirm(`${is_approved === 1 ? 'Disapprove' : 'Approve'} Affiliate?`)){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = true;
            }else{
                e.target.disabled = true;
            }
            const statusApiData = await post_api_call(`affiliate/approval-change`, {id: aff_tmp_id, is_approved: is_approved === 0 ? 1 : 0});
            if(statusApiData.status === 200){
                fetchAffiList();
                alertResponseMessage({alert_type: 1, message: `Affiliate ${is_approved === 1 ? 'Disapproved' : 'Approved'} Successfully!`});
            }
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          }
        }catch(e){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          error_api_call({error: `admin|affiliate|list|approveToggle|${e}`});
        }
    }
    // Toggle Modal
    const toggleModal = (e, modal_type, toggleState, index='', form_type='') => {
        try{
            if(toggleState){
                e.preventDefault();
            }
            setModalToggle({...modalToggle, [modal_type]: toggleState});
        }catch(error){
            console.log(error)
        }
    }

    return (
        <>
        <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body table-responsive sticky-table">
                {/* <h4 className="card-title">Basic Table</h4> */}
                {/* <p className="card-description"> Add class <code>.table</code></p> */}
                <table className="table">
                    <thead>
                    <tr>
                        <th>Aff. Tmp Id</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Country</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>Request Date<br/>(DD/MM/YYYY)</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {isLoading
                    ? 
                    <tr className="text-center"><td colSpan={8}><div className="p-4"><img alt="Loader" src={require('../../assets/images/Image-Loader.gif')} /></div></td></tr>
                    :
                    <>
                    {masterTableData.length === 0
                    ?
                        <tr className="text-center"><td colSpan={8}><p className="mt-4">No Data</p></td></tr>
                    :
                    <>
                    {masterTableData.map((data, data_index) => (
                        <tr key={`tableData_${data_index}`}>
                        <td>{data.id}</td>
                        <td>{data.first_name}</td>
                        <td>{data.last_name}</td>
                        <td>{data.country}</td>
                        <td>+{data.phone_code} {data.mobile_number}</td>
                        <td>{data.email}</td>
                        <td>{moment(data.created_at).format("DD/MM/yyyy")}</td>
                        <td>
                            <button onClick={(e) => loadViewModal(e, 'detail', data.id, data)} className="btn btn-sm btn-twitter" title="View Data"><i className="mdi mdi-eye"></i></button>
                            {data.is_approved === 0 && (
                              <>
                              {/* <button onClick={(e) => loadViewModal(e, 'config', data.id, data)} className={`btn btn-sm ms-2 btn-facebook`} title="Settings"><i className="mdi mdi-settings"></i></button> */}
                              <button onClick={(e) => approveToggle(e, 'approval', data.is_approved, data.id)} className={`btn btn-sm ms-2 ${data.is_approved === 1 ? 'btn-danger' : 'btn-success'}`} title="Approve"><i className="mdi mdi-check-outline"></i></button>
                              </>
                            )}
                        </td>
                        </tr>
                    ))}
                    </>
                    }
                    </>
                    }
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
        {/* View Details */}
        <ModalMasterDetail
            data={detailedAffData}
            isShow={modalToggle.detail}
            _toggleModal={(e, state) => toggleModal(e, 'detail', state)}
            loader={modalLoader.detail}
            _formData={[{label: "Basic Information", fields: [...fieldAffViewBasic]},
                        {label: "Affiliate Type", fields: [...fieldAffViewType]},
                        {label: "Reach & Channels", fields: [...fieldAffViewChannel]},
                        {label: "Marketing Plans", fields: [...fieldAffViewPlan]},
                        {label: "Payout Details", fields: [...fieldAffViewBank]}
                    ]}
            title={"Affiliate Details"}
        />
        {/* Config Settings */}
        {/* <ModalMaster
            isShow={modalToggle.config}
            _toggleModal={(e, state) => toggleModal(e, 'config', state)}
            modKey={activeEditForm}//config, edit
            formType={'config'}
            data={formNewData}
            title={masterTitle[activeEditForm]}
            _errorData={{...errorData}}
            _isProcess={{...isProcess}}
            // _isBtnDisabled={{...isBtnDisabled}}
            _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, variable_type, input_type, field, value)}
            _submitForm={(e, form_type) => updateHub(e, form_type)}
            _formData={[...masterFieldData]}
            selectOptions={{commission:
                            {value: 'id',
                            label: 'label',
                            data: [...optionComm],
                            }
                          }}
            // doc_url={docUrlData}
        /> */}
        </>
    )    
}

export default AffiliatePendingList;